import React from 'react';

import ProjectInformation from '../../components/ProjectInformation/ProjectInformation';

const ProjectDetail: React.FC = () => {
    return <ProjectInformation open={true} />;
};

export default ProjectDetail;
